import localforage from 'localforage';
import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

import type { SimpleItems } from '../utils/types';
import { calculationService } from '../utils/api/calculationService';

export const useItemsStore = defineStore(
  'items',
  () => {
    const data = ref<SimpleItems | null>(null);
    const itemsById = computed<Record<number, SimpleItems[0]>>(() => {
      const items: Record<number, SimpleItems[0]> = {};
      data.value?.forEach((item) => {
        items[item.id] = item;
      });

      return items;
    });

    async function getPricesFromLocalforage() {
      await localforage.getItem<SimpleItems>('prices');
    }

    async function fetch() {
      await getPricesFromLocalforage();

      if (!data.value) {
        data.value = await calculationService.getItems();
      }
    }

    function invalidate() {
      data.value = null;

      fetch();
    }

    function getItemById(id: number) {
      return data.value?.find((item) => item.id === id) || null;
    }

    function getItemValue(id: number) {
      const currentItem = getItemById(id);

      if (currentItem?.type === 'value') {
        return currentItem;
      }

      return null;
    }

    return {
      data,
      fetch,
      invalidate,
      getItemById,
      getItemValue,
    };
  },
  {
    // @ts-ignore
    persist: true,
  }
);
